import { defineStore } from 'pinia'
import {
  getAllProtocols,
  getProtocolById,
  getContactsForProtocol,
  setWatchStatusForProtocol
} from '@/api/protocol'
import type { ProtocolFilterAttributes, ProtocolListRequest } from '@/models/Filters'

interface ProtocolState {
  protocol_search_filter: ProtocolFilterAttributes | null
}

export const useProtocolStore = defineStore('protocol', {
  state: (): ProtocolState => ({
    protocol_search_filter: null
  }),

  actions: {
    updateProtocolSearchFilter(filters: ProtocolFilterAttributes | null) {
      this.protocol_search_filter = filters
    },

    async getAllProtocols(data: ProtocolListRequest) {
      const resp = await getAllProtocols(data)
      return resp.data
    },

    async getProtocolById(id: string) {
      const resp = await getProtocolById(id)
      return resp.data
    },

    async getContactsForProtocol(id: string) {
      const resp = await getContactsForProtocol(id)
      return resp.data
    },

    async setWatchStatusForProtocol(id: string, status: 'watch' | 'unwatch') {
      const resp = await setWatchStatusForProtocol(id, status)
      return resp.data
    }
  }
})
